import { Component, OnInit } from '@angular/core';
import { PelicanHRMContent } from '../../Models/Session';
import { BaseApiService } from '../../Services/base-api.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],standalone:false
})
export class FooterComponent implements OnInit {
  loading:boolean=false;
  sessionDataArray:PelicanHRMContent[]=[]
  constructor(private api :BaseApiService){

  }

  getPages() {
    this.loading = true;
    this.api.read('Page/GetAllPages').subscribe(
      (response) => {
        this.sessionDataArray = response;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  ngOnInit(): void {
    this.getPages();
  }
}
